module.exports = __webpack_public_path__ + "images/icons/icon-chevron-left-4083689b1eaf14e1c6a03f20e91f4053.svg";